import { ArtworkInfo, convertDimensionsInchesToMeters, getModelOnly } from "../utils/artwork-model-utils";
import { uploadV2 } from "../utils/media-utils";
import { getMediaType } from "../utils/custom-utils";
import { DIGTALIZATION_TECHNIQUE } from "../react-components/constants/artworks";

export class ArtworkHelper {
  static instance = null;

  static getInstance() {
    if (!ArtworkHelper.instance) {
      ArtworkHelper.instance = new ArtworkHelper();
    }
    return ArtworkHelper.instance;
  }

  calculateDimensionsAndScale({ dimensionsX, dimensionsY, dimensionsZ, unit }) {
    let dimensions;

    if (dimensionsX && dimensionsY && dimensionsZ) {
      dimensions = `${dimensionsY} x ${dimensionsX} x ${dimensionsZ} in`;
    } else if (dimensionsY && dimensionsX) {
      dimensions = `${dimensionsY} x ${dimensionsX} in`;
    } else if (dimensionsY || dimensionsX) {
      alert("Please fill in both Width and Height.");
      return { dimensions: "", scaleX: 1, scaleY: 1, scaleZ: 1 };
    } else {
      dimensions = "";
    }

    let scaleX, scaleY, scaleZ;
    if (dimensions) {
      const { xM, yM, zM } = convertDimensionsInchesToMeters(dimensionsX, dimensionsY, dimensionsZ);
      scaleX = xM;
      scaleY = yM;
      scaleZ = zM;
    }

    return { dimensions, scaleX, scaleY, scaleZ };
  }

  async generateArtworkData({
    artistName,
    artworkDate,
    dimensionsX,
    dimensionsY,
    dimensionsZ,
    unit,
    medium,
    dimensions,
    artistStatement,
    artName,
    description,
    fileUrl,
    imageUrl,
    mediums,
    glbModel,
    mediaType = "image",
    frameUrl,
    qrCodeId,
    isArtwork = true,
    ...rest
  }) {
    let {
      dimensions: dimensionsResult,
      scaleX,
      scaleY,
      scaleZ
    } = this.calculateDimensionsAndScale({ dimensionsX, dimensionsY, dimensionsZ, unit });
    // let scaleX, scaleY, scaleZ;
    const { isPublicDomainArt } = rest;
    if (dimensionsResult && !isPublicDomainArt) {
      dimensions = dimensionsResult;
    }

    const artworkData = {
      title: artName,
      artist: artistName,
      date: artworkDate,
      dimensions,
      dimensionsX,
      dimensionsY,
      dimensionsZ,
      medium,
      artist_statement: artistStatement,
      asset_type: "my-media",
      unit: unit || "in",
      metadata: rest
    };

    const isDigitalFile =
      medium?.model === "Digital File" ||
      medium === "Digital File" ||
      medium?.model === "Custom" ||
      medium === "Custom" ||
      medium?.model === null ||
      medium == "--";

    if (typeof medium === "object" && medium !== null) {
      artworkData.medium = medium.label;

      if (medium.model && !isDigitalFile && imageUrl) {
        glbModel = medium.model;
      }

      if (medium.label) {
        medium = medium.label;
      }
    }

    if (medium && !glbModel && !isDigitalFile && mediums) {
      glbModel = mediums.find(m => m.name === medium)?.model;
    }

    if (glbModel && isDigitalFile && imageUrl) {
      glbModel = null;
    }

    artworkData.glbModel = glbModel;

    if (mediaType != "image" && mediaType != "model") {
      return artworkData;
    }

    //prevent modifications on dimension model depending on digitalization technique
    if (DIGTALIZATION_TECHNIQUE[0] == artworkData?.metadata?.techniqueUsed && imageUrl) {
      scaleX = 1;
      scaleY = 1;
    }

    if (imageUrl && !scaleX && !scaleY) {
      const textureLoader = new THREE.TextureLoader();
      const texture = await textureLoader.loadAsync(imageUrl || fileUrl);

      const textureWidth = texture.image.width;
      const textureHeight = texture.image.height;

      const aspectRatio = textureWidth / textureHeight;

      // Set the scaling factor for x and y based on the aspect ratio
      if (aspectRatio > 1) {
        scaleX = aspectRatio;
        scaleY = 1;
      } else {
        scaleX = 1;
        scaleY = 1 / aspectRatio;
      }
    }

    const artworkInfo = new ArtworkInfo({
      title: artName,
      description,
      author: artistName,
      artworkDate: artworkDate,
      dimensions,
      medium: artworkData?.medium != "--" ? artworkData.medium : undefined,
      artistStatement,
      dimensionsX,
      dimensionsY,
      dimensionsZ,
      qrCodeId,
      metadata: rest
    }).toObject();
    //here
    const artwork = await getModelOnly({
      imageUrl: imageUrl && getMediaType(imageUrl) === "image" ? imageUrl : null,
      // imageUrl: mediaType == "image" ? fileUrl : null,
      scaleXArtwork: scaleX,
      scaleYArtwork: scaleY,
      artworkInfo: artworkInfo,
      glbModel,
      isDigitalFile: imageUrl && (!medium || isDigitalFile),
      frameUrl: imageUrl && getMediaType(imageUrl) === "image" ? frameUrl : null,
      reScale: true,
      qrCodeId,
      isArtwork
    });

    artworkData.scaleX = scaleX;
    artworkData.scaleY = scaleY;
    artworkData.scaleZ = scaleZ;

    const postData = {
      name: `${crypto.randomUUID()}-file.glb`,
      type: "model/gltf-binary"
    };

    const artworkFile = new File([artwork], postData.name, {
      type: postData.type
    });

    artworkData.artworkInfo = artworkInfo;

    const artworkResponse = await uploadV2(artworkFile, postData.type, { includeThumbnail: false, hidden: 1 });
    artworkData.artwork_model = artworkResponse?.data?.url;
    return artworkData; // Only returning artworkResponse as requested
  }
}
